// App-wide light/dark theme. Persisted globally (not per-user) so it applies at
// the login screen too. Drives the CSS `data-theme` attribute and the canvas Theme.
import { setChartTheme } from "../chart/theme";

export type Mode = "light" | "dark";
const KEY = "mytv.theme";

export function currentMode(): Mode {
  try {
    return localStorage.getItem(KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function applyMode(m: Mode) {
  document.documentElement.dataset.theme = m;
  setChartTheme(m);
}

export function initTheme() {
  applyMode(currentMode());
}

export function setMode(m: Mode) {
  try {
    localStorage.setItem(KEY, m);
  } catch {}
  applyMode(m);
}

export function toggleMode(): Mode {
  const next: Mode = currentMode() === "dark" ? "light" : "dark";
  setMode(next);
  return next;
}

// sun / moon glyphs for toggle buttons
export function themeIcon(mode: Mode): string {
  return mode === "dark"
    ? `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>`
    : `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2.2M12 19.8V22M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2 12h2.2M19.8 12H22M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6"/></svg>`;
}
